import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { Lock } from "@mui/icons-material";
import { useGetMyInfoQuery, useWithdrawMutation } from "../apis/users";

const Mypage = () => {
  const { data: profile } = useGetMyInfoQuery();
  const [withdraw] = useWithdrawMutation();
  const handleDelete = () => withdraw();

  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4">Account</Typography>
        <form autoComplete="off">
          <Card>
            <CardHeader title="Profile" subheader="The information can be edited" />
            <CardContent sx={{ pt: 0 }}>
              <Grid container spacing={3}>
                <Grid item md={6}>
                  <TextField name="name" label="Name" value={profile?.name} fullWidth required />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    name="email"
                    label="Email Address"
                    value={profile?.email}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <Button variant="contained">Save details</Button>
            </CardActions>
          </Card>
        </form>
        <Card>
          <CardHeader title="Change Password" />
          <CardContent>
            <TextField
              label="Old password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="New password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Confirm new password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
              }}
            />
          </CardContent>
          <Divider />
          <CardActions sx={{ justifyContent: "flex-end" }}>
            <Button variant="contained" onClick={handleDelete}>
              Update password
            </Button>
          </CardActions>
        </Card>
        <Card>
          <CardHeader title="Delete user" />
          <CardContent>
            Once you delete your user, there is no going back. Please be certain.
          </CardContent>
          <Divider />
          <CardActions sx={{ justifyContent: "flex-end" }}>
            <Button variant="contained" color="error">
              Delete user
            </Button>
          </CardActions>
        </Card>
      </Stack>
    </Container>
  );
};

export default Mypage;
